import React, { useState } from "react";
import "./minter.css";
import { totalSupply, getAddress } from "../../utils/interact";

function Minter(props) {
  const [supply, setSupply] = useState("");

  const Subtract = () => {
    if (props.amount > 1) {
      props.setAmount(parseInt(props.amount) - 1);
    }
  };

  const Add = () => {
    if (props.amount < 30) {
      props.setAmount(parseInt(props.amount) + 1);
    }
  };

  const minted = async () => {
    await getAddress();
  };

  const handleChange = (event) => {
    props.setAmount(event.target.value);
  };

  return (
    <section id="minter" className="container minter_container">
      <h2>Mint MonkeyDoo 🐵 NFTs</h2>
      {props.supply === 0 ? (
        <p
          style={{
            fontSize: "1.3rem",
          }}
        >
          {" "}
          About 50% minted out. Connect to see the number minted.
        </p>
      ) : (
        <h5>
          Total Minted: <span> {props.supply} of 3,000 </span>
        </h5>
      )}
      <div className="progressBar">
        <div
          className="progress"
          style={{
            width: Math.floor((props.supply / 3000) * (100 / 100) * 100) + "%",
          }}
        ></div>
      </div>
      <div className="mint_value">
        <h5>
          {props.amount} NFT = {props.amount * 1} ETC
        </h5>
        <h3>Unlimited MonkeyDoo per transaction</h3>
      </div>
      <div className="mint_section">
        <div className="mint_box">
          <div className="mint">
            <button onClick={() => Subtract()}> - </button>
            {/* <span> {counter}</span> */}
            <input
              value={props.amount}
              type="number"
              style={{
                width: "50px",
                background: "inherit",
                textAlign: "center",
              }}
              onChange={handleChange}
            />
            {/* onChange={handleChange} */}
            <button onClick={() => Add()}> + </button>
          </div>

          {/* <button className="circle_button" onClick={() => setCounter(5)}>
            {" "}
            5{" "}
          </button>
          <button className="circle_button" onClick={() => setCounter(10)}>
            {" "}
            10{" "}
          </button>
          <button className="circle_button" onClick={() => setCounter(20)}>
            {" "}
            20{" "}
          </button> */}
        </div>
        <span>{props.status}</span>
        <br />

        <div>
          {props.supply === 3000 ? null : (
            <a
              // className="nav_link button_type free_button alternate"
              // className="nav_link button_type equal_button"
              style={{
                width: "100px",
              }}
            >
              {props.loading === true ? (
                <span>Loading.....</span>
              ) : (
                // <span>Mint</span>
                <button className="btn btn-primary" onClick={props.mint}>
                  Mint Now !
                </button>
                // <span className="section_text smaller">
                //   Minting Coming Soon
                // </span>
              )}
            </a>
          )}
        </div>

        <h3 className="contract">
          <a
            target="_blank"
            href="https://blockscout.com/etc/mainnet/address/0xE86ae8f38372d26F8ffAC37deba733a77f101Ac7/transactions"
          >
            View Contract
          </a>
        </h3>

        <h5>
          Please use Chrome/Firefox with metamask extension for PC or metamask
          app for mobile
        </h5>
      </div>
    </section>
  );
}

export default Minter;
